import React from 'react'
import { Box, Typography as Text } from '@material-ui/core'

const ItemCounter = React.forwardRef(
  ({ numOfItems, itemNum, classes }, ref) => (
    <Box ref={ref} className={classes.itemCounter}>
      <Text>
        {itemNum}of{numOfItems}
      </Text>
    </Box>
  ),
)
export default ItemCounter
